import React from "react";
import PropTypes from "prop-types";

const styles = {
  title: "text-lg font-semibold text-primary my-4",
  sectionCard: "rounded-lg p-5 md:p-6",
  helperText: "text-base text-muted-foreground",
  divider: "border-t border-[#768692]",
  grid2: "grid gap-6 md:grid-cols-2",
  label: "mb-1 text-primary",
  input:
    "mt-2 mb-4 w-full border-0 border-b border-neutral-300 px-0 py-1 text-lg text-neutral-600 outline-none disabled:cursor-not-allowed",
};

function IdentityField({ label, name, value }) {
  return (
    <div className="flex flex-col">
      <label
        className={styles.label}
        data-testid={`patient-initiation-identity-label-${name}`}
      >
        {label}
      </label>
      <input
        type="text"
        name={name}
        value={value || ""}
        className={styles.input}
        disabled
        data-testid={`patient-initiation-identity-field-${name}`}
      />
    </div>
  );
}

IdentityField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
};

export default function ConfirmIdentity({ personalDetails }) {
  return (
    <div
      className="space-y-5"
      data-testid="patient-initiation-confirmation-identity"
    >
      <h1
        className={styles.title}
        data-testid="patient-initiation-identity-title"
      >
        Please confirm your identity
      </h1>
      <hr className={styles.divider} />

      <div className="min-h-125 space-y-3">
        <p
          className={styles.helperText}
          data-testid="patient-initiation-identity-helper"
        >
          Please ensure that the following details are correct before proceeding.
          If any details are incorrect, please navigate to your profile before clicking begin.
        </p>

        <section
          className={styles.sectionCard}
          data-testid="patient-initiation-identity-personal-details"
        >
          <h2
            className="mb-4 text-lg font-semibold text-primary"
            data-testid="patient-initiation-identity-personal-details-label"
          >
            Personal Details
          </h2>

          <div className="grid gap-6">
            <div className={styles.grid2}>
              <IdentityField label="Prescriber First Name" name="first_name" value={personalDetails?.first_name} />
              <IdentityField label="Prescriber Last Name" name="last_name" value={personalDetails?.last_name} />
            </div>

            <div className={styles.grid2}>
              <IdentityField label="Registration Number" name="registration_number" value={personalDetails?.registration_number} />
              <IdentityField label="Job Title" name="job_title" value={personalDetails?.job_title} />
            </div>

            <div className={styles.grid2}>
              <IdentityField label="Hospital Name" name="hospital_name" value={personalDetails?.hospital_name} />
              <IdentityField label="Address" name="hospital_address" value={personalDetails?.hospital_address} />
            </div>

            <div className={styles.grid2}>
              <IdentityField label="Email" name="email" value={personalDetails?.email} />
              <div className="hidden md:block" aria-hidden="true" />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

ConfirmIdentity.propTypes = {
  personalDetails: PropTypes.object,
};
